var Shop = {

	buy: function(item) {
		Api.post('/shop/buy', {item: item}, function(r){
			if(r.success){
				Store.update(r.coins, undefined, undefined, undefined, r.items);
				$('#amount_items_'+item).html(r.quantyI);
				Alert.push([{type: 'success', text: 'Tu compra se ha efectuado con éxito, agrega y contacta con Habtium en el hotel para la entrega respectiva.', icon: 'check'}]);
			} else {
				switch(r.error.identifier){
					case 'item_not_found':
						Alert.push([{type: 'danger', text: '¡Oops! El item que intentas comprar no existe.', icon: 'triangle-alert'}]);
						break;
					case 'countable_items_not_allowed':
						Alert.push([{type: 'danger', text: '¡Oops! El item que intentas comprar está agotado.', icon: 'triangle-alert'}]);
						$('#buy_item_btn_'+item).each(function(){
							$(this).remove();
						});
						$('#amount_items_'+item).html(0);
						break;
					case 'account_doesnt_have_coins':
						Alert.push([{type: 'danger', text: '¡Oops! Tu cuenta no tiene suficientes monedas para realizar esta compra.', icon: 'triangle-alert'}]);
						$('#buy_item_btn_'+item).each(function(){
							$(this).removeClass('green').addClass('red disabled');
						});
						break;
					case 'new_total_coins_exceed_monthly':
						Alert.push([{type: 'danger', text: '¡Oops! Esta transacción no puede realizarse o excederías el total de monedas mensuales.', icon: 'triangle-alert'}]);
						break;
					case 'total_coins_monthly_exceed':
						Alert.push([{type: 'danger', text: '¡Oops! Has utilizado el tope de monedas mensuales.', icon: 'triangle-alert'}]);
						break;
					case 'furni_buy_exceeded':
						Alert.push([{type: 'danger', text: '¡Oops! Yas has adquirido tus 3 items semanales.', icon: 'triangle-alert'}]);
						break;
					case 'account_time_not_available':
						Alert.push([{type: 'danger', text: '¡Oops! Tu cuenta no posee al menos 2 meses de registro.', icon: 'triangle-alert'}]);
						break;
					case 'habbo_account_doesnt_verified':
						Alert.push([{type: 'danger', text: '¡Oops! Tu habbo cuenta no está verificada.', icon: 'triangle-alert'}]);
						break;
					case 'item_is_not_buyable':
						Alert.push([{type: 'danger', text: '¡Oops! El item que intentas comprar no está disponible en este momento.', icon: 'triangle-alert'}]);
						break;
					case 'afro_is_required':
						Alert.push([{type: 'danger', text: '¡Oops! El item que intentas comprar solo está disponible para miembros del club afro.', icon: 'triangle-alert'}]);
						break;
				}
			}
		});
	}

}
